<!-- <app-page-header [header]="'quotations'|translate" [breadcrumbs]="[
{label: 'Home',       url: '/'},
{label: 'Quotation', url: '/quotation-cart'},
{label: 'Requested Quotations', url: '/quotation/requested'}
]"></app-page-header> -->

<div *ngIf="!quotationDetails && !loading" fxLayout="row" fxLayoutAlign="center center">Error Loading Data</div>

<div *ngIf="quotationDetails" fxLayout="row" fxLayoutAlign="center center">

    <div class="container">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div style="font-size: x-large; font-weight: 400;" class="my-2">{{"quotation_details"|translate}}: <span class="mx-2">{{quotationDetails.invoiceReference}}</span></div>
            <div fxFlexAlign="center center" *ngIf="quotationDetails" [ngStyle.xs]="{padding: '12px', 'font-size.px':11, hieght: 'min-content'}" style="height: min-content; text-align: center; padding: 10px 10px 10px 10px;">{{"quotation_status"|translate}}:
                <span [style.color]="status[quotationDetails?.status]?.color">
                    {{status[quotationDetails?.status]?.text }}</span>
            </div>
        </div>

        <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
            <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"review_quotation"|translate}}</div>
            <div>
                <a routerLink="/" class="sm:mt-0 btn btn-primary">{{"continue_shopping"|translate}}</a>
                <a [href]="printQuotation()" class="ms-2 sm:mt-0 ms-0" target="_blank" *ngIf="quotationDetails?.status =='accepted' || quotationDetails?.status =='offered'|| quotationDetails?.status =='renegotiated'">
                    <mat-icon>print</mat-icon>
                </a>
            </div>
        </div>

        <div>
            <mat-tab-group>
                <mat-tab [label]="'general'|translate">
                    <div class="card-table">
                        <div class="table-responsive-sm">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{{"item"|translate}}</th>
                                        <th>{{"amount"|translate}}</th>
                                        <th>{{"unit_total"|translate}} <div class="text-xxs">{{"inclusive"|translate}}</div>
                                        </th>
                                        <th>{{"discount_total"|translate}}</th>
                                        <th>{{"item_total"|translate}} <div class="text-xxs">{{"inclusive"|translate}}</div>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody class="card-table__body card-table__body--merge-rows">
                                    <tr *ngFor="let item of items">
                                        <td>
                                            <a [routerLink]="((item.sector) ? ['sector', item.sector] : ['/']).concat([item.product.layout || item.product.type, item.product.seo?.slug])" class="cart-table__product-name"> {{ translateHelper.localize(item.product?.name) }}</a>
                                            <app-options-details [options]="item.options" [variant]="item.variant"></app-options-details>


                                            <div class="mx-4" *ngIf="item.serviceData">
                                                <app-booking-details [serviceData]="item.serviceData" [dateType]="item.product?.dateType" [timeType]="item.product?.timeType"></app-booking-details>

                                            </div>

                                        </td>

                                        <td data-title="Quantity">
                                            <span>{{item.amount|number}}</span>
                                            <div *ngIf="item?.amount == null"> - </div>
                                        </td>

                                        <td data-title="Unit Total">
                                            <span>{{item.unitTotalTaxed|currencyFormat}}</span>
                                            <div *ngIf="item?.unitTotalTaxed == null"> - </div>
                                        </td>
                                        <td data-title="Discount Total">
                                            <span>{{item.discountTotal|currencyFormat}}</span>
                                            <div *ngIf="item?.discountTotal == null"> - </div>
                                        </td>
                                        <td data-title="Item Total">
                                            <span>{{item.total|currencyFormat}}</span>
                                            <div *ngIf="item?.total == null"> - </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                    <div class="justify-end me-2 sm:flex flex-row">
                        <div class="float-left sm:items-start me-2 font-bold">
                            <div>{{"subtotal"|translate}}:</div>
                            <div>{{"special_discount"|translate}}:</div>
                            <div>{{"taxes_total"|translate}}:</div>
                            <div>{{"total"|translate}}:</div>
                        </div>
                        <div class="float-right sm:items-end">
                            <div>{{ quotationDetails?.subtotal|currencyFormat }}</div>
                            <div>{{ quotationDetails?.discountTotal|currencyFormat }}</div>
                            <div>{{ quotationDetails?.taxTotal|currencyFormat }}</div>
                            <div>{{ quotationDetails?.total|currencyFormat }}</div>
                        </div>
                    </div>
                </mat-tab>


                <mat-tab [label]="'messages'|translate">
                    <div *ngIf="quotationDetails" style="border: 1px solid lightgray; margin: 3px;" fxLayout="column">
                        <div style=" border: 1px solid lightgray; background-color: rgba(211, 211, 211, 0.253); margin: 3px;" fxLayout="column" fxLayoutAlign="center center">
                            <div style="width: 100%;" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="m-2" fxLayout="row" fxLayoutAlign="start center">
                                    <img *ngIf="_.findKey(quotationDetails?.companyData?.images)" [src]="quotationDetails?.companyData?.images[_.findKey(quotationDetails?.companyData?.images)].url" class="avatar">
                                    <div class="mx-4">{{translateHelper.localize(quotationDetails?.companyData?.name)}}</div>
                                </div>

                                <!-- <button mat-button>
                                    <mat-icon>more_vert</mat-icon>
                                </button> -->
                            </div>
                        </div>
                        <app-quotation-messages [quotationDetails]="quotationDetails"></app-quotation-messages>
                    </div>
                </mat-tab>


            </mat-tab-group>



        </div>
        <div class="flex flex-row content-start justify-start sm:content-end justify-end mb-2 mt-2">

            <button *ngIf="quotationDetails?.status =='accepted'" type="button" (click)="addToCart()" mat-flat-button class="m-1 text-xxs sm:text-sm" color="primary">{{"add_cart"|translate}}</button>

            <button *ngIf="quotationDetails?.status =='offered'" type="button" (click)="updateQuotationStatus('accept')" mat-flat-button class="m-1 text-xxs sm:text-sm" color="primary">{{"accept_offer"|translate}}</button>

            <button *ngIf="quotationDetails?.status =='new'" type="button" (click)="updateQuotationStatus('cancel')" mat-flat-button class="m-1 text-xxs sm:text-sm" color="primary">{{"cancel_quotation"|translate}}</button>

            <button *ngIf="quotationDetails?.status =='offered'" type="button" (click)="updateQuotationStatus('reject')" mat-flat-button class="m-1 text-xxs sm:text-sm" color="primary">{{"reject_offer"|translate}}</button>

            <button *ngIf="quotationDetails?.status =='offered'" type="button" (click)="updateQuotationStatus('renegotiate')" mat-flat-button class="m-1 text-xxs sm:text-sm" color="primary">{{"renegotiate_offer"|translate}}</button>

        </div>
    </div>





</div>